import SystemSetting from './SystemSettingApi'

var Api = new SystemSetting({
  // url: (process.env.NODE_ENV === 'development') ? 'http://10.0.0.20:8088' : 'http://10.0.0.20:8088'
  url: 'https://manuerpapi.mybrandapp.org'
})

export default Api



// WEBPACK FOOTER //
// ./src/View/SystemSetting/SystemSettingApi/API.js